<template>
  <md-dialog :md-active.sync="showDialog">
    <md-dialog-title>
      Provision Tenant
      <strong>{{ currentTenant.name }}</strong>
    </md-dialog-title>
    <md-dialog-content class="md-scrollbar">
      <md-card>
        <md-card-content>
          <div class="md-layout">
            <div
              class="md-layout-item md-small-size-100 md-size-100"
              style="min-width: 600px"
            >
              <md-tabs
                class="md-danger"
                md-alignment="centered"
                :md-active-tab="activeTab"
              >
                <md-tab
                  id="tab-provision"
                  md-icon="cloud"
                  md-label="Provision"
                  :md-disabled="isProvisionInProgress"
                >
                  <div class="md-layout">
                    <div
                      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
                    >
                      <div class="md-layout">
                        <div
                          class="md-layout-item md-size-100"
                          v-if="!hasDeploymentEnvironmentSet"
                        >
                          <!-- No environment is selected on this tenant, show only the error message -->
                          <h4>
                            <b>
                              No Deployment Environment has been set for the
                              tenant.
                            </b>
                          </h4>
                          <h6>
                            Close this dialog and edit the tenant to select the
                            environment before trying to provision.
                          </h6>
                        </div>
                        <div v-else class="md-layout-item md-size-100">
                          <!-- An environment is selected on this tenant, show first the region, then the stages -->
                          <md-progress-bar
                            md-mode="query"
                            v-if="!selectedRegion"
                          ></md-progress-bar>
                          <div class="md-layout" v-else>
                            <div class="md-layout-item md-size-100">
                              <h5>Region & stages</h5>
                              <md-field>
                                <label>Select region</label>
                                <md-select
                                  name="region"
                                  id="region"
                                  v-model="selectedRegion"
                                  disabled
                                >
                                  <md-optgroup label="Region">
                                    <md-option
                                      v-for="(
                                        item, key
                                      ) in availableRegionsAndStages"
                                      :key="key"
                                      :value="key"
                                    >
                                      {{ getRegionHeader(key) }}
                                    </md-option>
                                  </md-optgroup>
                                </md-select>
                              </md-field>
                            </div>
                            <div
                              class="md-layout-item md-size-100"
                              v-if="selectedRegion"
                            >
                              <md-field>
                                <label>Select stages</label>
                                <md-select
                                  name="stages"
                                  id="stages"
                                  v-model="selectedStages"
                                  multiple
                                >
                                  <md-optgroup label="Stages">
                                    <md-option
                                      v-for="(
                                        item, key
                                      ) in availableRegionsAndStages[
                                        selectedRegion
                                      ]"
                                      :key="key"
                                      :value="item.key"
                                    >
                                      {{ item.stageName }}
                                    </md-option>
                                  </md-optgroup>
                                </md-select>
                              </md-field>
                              <div v-if="showSkipWarning" class="warning-text">
                                <md-icon class="md-accent">warning</md-icon>
                                <span style="font-weight: 400">
                                  You are skipping a deployment target in a
                                  lower stage.
                                </span>
                              </div>
                            </div>
                            <div class="md-layout-item md-size-100" v-if="availableClusters.length > 0">
                              <md-field>
                                <label>Select cluster</label>
                                <md-select
                                  name="cluster"
                                  id="cluster"
                                  v-model="selectedCluster"
                                  v-if="availableClusters.length > 0"
                                >
                                  <md-optgroup label="Clusters">
                                    <md-option
                                      v-for="cluster in availableClusters"
                                      :key="cluster"
                                      :value="cluster"
                                    >
                                      {{ cluster }}
                                    </md-option>
                                  </md-optgroup>
                                </md-select>
                              </md-field>
                            </div>
                            <div
                              class="md-layout-item md-size-100"
                              v-if="selectedStages.length > 0"
                            >
                              <h5>Products to deploy</h5>
                              <div class="md-layout-item md-size-100">
                                <ul class="no-style-list">
                                  <li>
                                    <md-checkbox
                                      v-model="enabledProducts.cm.value"
                                    >
                                      FRISS Screening Center
                                      <span v-if="deployCloudFsc">
                                        <b>Cloud</b>
                                      </span>
                                    </md-checkbox>
                                  </li>

                                  <li>
                                    <md-checkbox
                                      v-if="
                                        canShowDeployFIToggle && isCaseDomain
                                      "
                                      v-model="enabledProducts.facts.value"
                                    >
                                      FRISS Investigations
                                    </md-checkbox>
                                    <md-checkbox
                                      v-else
                                      v-model="enabledProducts.facts.value"
                                      disabled
                                    >
                                      FRISS Investigations
                                      <span
                                        v-if="
                                          !canShowDeployFIToggle && isCaseDomain
                                        "
                                      >
                                        (Only for SPA, ACC, and PRD)
                                      </span>
                                    </md-checkbox>
                                  </li>

                                  <li>
                                    <md-checkbox
                                      v-model="deployCloudFsc"
                                      disabled
                                    >
                                      FRISS Cloud
                                    </md-checkbox>
                                  </li>

                                  <li>
                                    <md-checkbox v-model="isTrue" disabled>
                                      FRISS Network Viewer
                                    </md-checkbox>
                                  </li>

                                  <li>
                                    <md-checkbox
                                      v-model="enabledProducts.audit.value"
                                    >
                                      FRISS Audit (Legacy)
                                    </md-checkbox>
                                  </li>

                                  <li>
                                    <md-checkbox
                                      v-model="enabledProducts.sideBySide.value"
                                    >
                                      Side By Side (Legacy)
                                    </md-checkbox>
                                  </li>

                                  <li>
                                    <md-checkbox
                                      v-model="enabledProducts.ssrs.value"
                                    >
                                      SSRS Reports (Legacy)
                                    </md-checkbox>
                                  </li>

                                  <li>
                                    <md-checkbox
                                      v-model="enabledProducts.tenantWeb.value"
                                    >
                                      Tenant Web
                                    </md-checkbox>
                                  </li>

                                  <li>
                                    <md-checkbox v-model="isTrue" disabled>
                                      Data Lake Integration
                                    </md-checkbox>
                                  </li>

                                  <li>
                                    <md-checkbox v-model="isTrue" disabled>
                                      Single Sign On
                                    </md-checkbox>
                                  </li>
                                </ul>
                              </div>
                              <div class="md-layout-item md-size-100">
                                <md-checkbox v-model="addSupportAsAdmin">
                                  Add members of Support as Tenant Administrator
                                  <br />
                                </md-checkbox>
                              </div>
                            </div>
                          </div>
                        </div>
                        <br />
                      </div>
                    </div>
                  </div>
                </md-tab>

                <md-tab
                  id="tab-status"
                  md-icon="track_changes"
                  md-label="Status"
                  :md-disabled="!isProvisionInProgress"
                >
                  <provision-status
                    v-if="isProvisionInProgress"
                    :provision-response-metadata="provisionResponseMetadata"
                  />
                </md-tab>
              </md-tabs>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </md-dialog-content>
    <md-dialog-actions>
      <md-button @click="onClose">Close</md-button>
      <md-button
        class="md-primary"
        @click="save"
        :disabled="!isValid || isProvisionInProgress"
      >
        Provision
      </md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import ProvisionStatus from "@/components/ProvisionStatus/ProvisionStatus";
import { PRODUCT_FLAG_CODES } from "@/components/ProvisionsPlugin/ProvisionConstants";

const provisionApiCode = window.VUE_APP_PROVISION_API_CODE;

export default {
  name: "ProvisionDialog",
  components: { ProvisionStatus },
  data() {
    return {
      activeTab: "tab-provision",
      availableRegionsAndStages: [],
      selectedRegion: "",
      selectedStages: [],
      selectedCluster: "",
      provisionResponseMetadata: null,
      provisionStatus: null,
      pollStatusTimerId: null,
      addSupportAsAdmin: true,
      isTrue: true,
      products: [
        "CaseManagement - Configuration",
        "Tenant Web",
        "Friss Audit",
        "Side by Side",
        "SSRS Reports",
        "Facts! 5"
      ],
      enabledProducts: {
        cm: {
          name: "CaseManagement - Configuration",
          value: true
        },
        facts: {
          name: "Facts! 5",
          value: false
        },
        tenantWeb: {
          name: "Tenant Web",
          value: true
        },
        audit: {
          name: "Friss Audit",
          value: true
        },
        sideBySide: {
          name: "Side by Side",
          value: true
        },
        ssrs: {
          name: "SSRS Reports",
          value: true
        }
      }
    };
  },
  async created() {
    try {
      const regionsResponse =
        await this.$featureFlagApi.get("/regions/express");

      this.availableRegionsAndStages = regionsResponse.data;

      if (this.isDevelopmentEnvironment) {
        this.availableRegionsAndStages = this.onlyInternalRegion(
          this.availableRegionsAndStages
        );
        this.selectedRegion = "internal";
      } else {
        this.availableRegionsAndStages = this.excludeInternalRegion(
          this.availableRegionsAndStages
        );
        this.selectedRegion = this.camelize(
          this.$tenantStore.state.currentTenant.deploymentEnvironment
        );
      }
    } catch (error) {
      console.log("Error fetching regions and stages:", error);
      this.$notify({
        message: "Failed to read data necessary to Deploy",
        icon: "running_with_errors",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "danger"
      });
    }
  },
  watch: {
    selectedStages: function (stages) {
      if (this.checkCanShowDeployFIToggle(stages) && this.isCaseDomain) {
        this.enabledProducts.facts.value = true;
      } else {
        this.enabledProducts.facts.value = false;
      }
    }
  },
  computed: {
    showDialog() {
      return this.$tenantStore.state.showProvisionDialog;
    },
    currentTenant() {
      return this.$tenantStore.state.currentTenant;
    },
    isValid() {
      return this.selectedRegion.length > 0 || this.selectedStages.length > 0;
    },
    hasDeploymentEnvironmentSet() {
      return this.$tenantStore.state.currentTenant.deploymentEnvironment;
    },
    isProvisionInProgress() {
      return this.activeTab === "tab-status" || !!this.provisionStatus;
    },
    canShowDeployFIToggle() {
      return this.checkCanShowDeployFIToggle(this.selectedStages);
    },
    deployFI() {
      return this.canShowDeployFIToggle && this.isCaseDomain;
    },
    deployCloudFsc() {
      return this.$tenantStore.state.currentTenant.fscCloud;
    },
    isCaseDomain() {
      return this.currentTenant.domain.includes("case") === true;
    },
    availableClusters() {
      if (!this.selectedRegion) return [];
      if (!Array.isArray(this.selectedStages) || this.selectedStages.length === 0) return [];

      const stagesInRegion = this.availableRegionsAndStages[this.selectedRegion] || [];
      const allClusters = stagesInRegion
          .filter(stage => stage && this.selectedStages.includes(stage.key))
          .flatMap(stage => Array.isArray(stage?.clusters)
            ? stage.clusters
            : []);

      return [...new Set(allClusters)];
    },
    skippedProducts() {
      let toSkip = [];
      if (!this.enabledProducts.cm.value)
        toSkip.push(this.enabledProducts.cm.name);
      if (!this.enabledProducts.facts.value)
        toSkip.push(this.enabledProducts.facts.name);
      if (!this.enabledProducts.tenantWeb.value)
        toSkip.push(this.enabledProducts.tenantWeb.name);
      if (!this.enabledProducts.audit.value)
        toSkip.push(this.enabledProducts.audit.name);
      if (!this.enabledProducts.sideBySide.value)
        toSkip.push(this.enabledProducts.sideBySide.name);
      if (!this.enabledProducts.ssrs.value)
        toSkip.push(this.enabledProducts.ssrs.name);
      return toSkip;
    },
    isDevelopmentEnvironment() {
      return (
        this.$tenantStore.state.currentTenant.deploymentEnvironment ===
        "Development"
      );
    },
    isProductionEnvironment() {
      return !this.isDevelopmentEnvironment;
    },
    showSkipWarning() {
      const availableStages =
        this.availableRegionsAndStages[this.selectedRegion];

      let maxSelectedIndex = -1;
      for (let i = 0; i < availableStages.length; i++) {
        if (this.selectedStages.includes(availableStages[i].key)) {
          maxSelectedIndex = i;
        }
      }
      for (let i = 0; i <= maxSelectedIndex; i++) {
        if (!this.selectedStages.includes(availableStages[i].key)) {
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    onClose() {
      this.$tenantStore.closeProvisionDialog();
      this.provisionStatus = null;
    },
    getRegionHeader(key) {
      return key.replace(/([A-Z])/g, " $1").replace(/^./, function (str) {
        return str.toUpperCase();
      });
    },
    excludeInternalRegion(regions) {
      const filtered = Object.fromEntries(
        Object.entries(regions).filter(([k, v]) => k !== "internal")
      );
      return filtered;
    },
    onlyInternalRegion(regions) {
      const filtered = Object.fromEntries(
        Object.entries(regions).filter(([k, v]) => k === "internal")
      );
      return filtered;
    },
    camelize(str) {
      return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
        if (+match === 0) return "";
        return index === 0 ? match.toLowerCase() : match.toUpperCase();
      });
    },
    checkCanShowDeployFIToggle(selectedStages) {
      // FRISS Investigations can only be deployed for Production stack or Internal SPA stage
      if (this.isProductionEnvironment) {
        return true;
      }
      const hasSpaStageSelected = selectedStages.some(
        s => s.split("-")[1] === "spa"
      );
      return hasSpaStageSelected;
    },
    async save() {
      const stages = [];

      for (let stageCode of this.selectedStages) {
        const stageComponents = stageCode.split("-"); // stageCode is like "nl-spa"
        const region = stageComponents[0];
        const stage = stageComponents[1];

        if (this.isDevelopmentEnvironment) {
          // Disable FRISS Investigate deployment for internal stages, except SPA.
          if (stage !== "spa") {
            this.deployFI = false;
          }
        }

        stages.push({ region: region, stage: stage });
      }

      let additionalProducts = [
        ...(this.deployFI ? [PRODUCT_FLAG_CODES.FI] : []),
        ...(this.deployCloudFsc ? [PRODUCT_FLAG_CODES.CLOUD_FSC] : [])
      ];

      const expressRequest = {
        TenantCode: this.currentTenant.tenantCode,
        Name: this.currentTenant.name,
        Product: this.currentTenant.product,
        Country: this.currentTenant.country,
        Culture: this.currentTenant.language,
        Domain: this.currentTenant.domain,
        TenantGroup: this.currentTenant.tenantGroup,
        TenantAdmins: this.currentTenant.tenantAdmins,
        AddSupportMembersAsTenantAdmin: this.addSupportAsAdmin,
        Stages: stages,
        Cluster: this.selectedCluster,
        AdditionalProducts: additionalProducts,
        SkipProducts: this.skippedProducts
      };

      this.activeTab = "tab-status";
      const header = {
        headers: {
          "requested-by":
            this.$msal.user.profile.email || this.$msal.user.userName
        }
      };
      await this.$provisionApi
        .post(
          `/provision/express?code=${provisionApiCode}`,
          expressRequest,
          header
        )
        .then(async result => {
          this.provisionResponseMetadata = result.data;
        })
        .catch(error => {
          let message = "Error contacting provisioning api...";
          this.provisionStatus.customStatus = message;
          this.$notify({
            message: message,
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "danger"
          });
        });
    }
  }
};
</script>

<style scoped>
.md-tabs {
  margin-top: 24px !important;
  margin-left: -20px;
  margin-right: -20px;
}

.md-tab-nav-button {
  height: 32px !important;
}

.md-dialog-content {
  max-width: 1280px;
}

.no-style-list {
  list-style-type: none;
}

.md-checkbox {
  margin: 5px 5px 5px 0;
}
</style>
